export default "__VITE_ASSET__a54380e1__"